import axios from 'axios';
import { CompobotLogType } from 'types/compobot-log.type';
import { TopUserByCompobotDto } from '../types/top-user-by-compobot.type';

export const getCompobotLogs = (
  compobotId: string,
  startDate: Date,
  endDate: Date,
) => {
  // Backend: GET /compobot-log/compobot/:id?from&to  →  VÁLASZ: CompobotLogType[]
  return axios.get<CompobotLogType[]>(
    `compobot-log/compobot/${compobotId}`,
    {
      params: {
        from: startDate.toISOString(),
        to: endDate.toISOString(),
      },
    },
  );
};

export const getTopUsersByCompobot = (
  compobotId: string,
  opts?: { from?: Date; to?: Date; limit?: number; offset?: number }
) => {
  const params: any = {};
  if (opts?.from) params.from = opts.from.toISOString();
  if (opts?.to)   params.to   = opts.to.toISOString();
  if (opts?.limit != null)  params.limit  = opts.limit;
  if (opts?.offset != null) params.offset = opts.offset;

  return axios.get<TopUserByCompobotDto[]>(
    `compobot-log/compobot/${compobotId}/top-users`,
    { params }
  );
};